import React, { memo } from 'react';
import noop from 'lodash/noop';
import { RealtimeProvider } from '@atlassian/jira-realtime/src/services/realtime-provider/index.tsx';
import { APP_ID } from '../../model/constants.tsx';
import { useBacklogSelector } from '../../state/index.tsx';
import { realtimeChannelsSelector } from '../../state/selectors/realtime/index.tsx';

export type Props = {
	children: JSX.Element;
};

const Realtime = memo((props: Props) => {
	const realtimeChannels = useBacklogSelector(realtimeChannelsSelector);

	if (realtimeChannels?.length === 0) {
		return props.children;
	}

	return (
		<RealtimeProvider
			appId={APP_ID}
			onJoin={noop}
			onReceive={noop}
			onLeave={noop}
			channels={realtimeChannels}
		>
			{props.children}
		</RealtimeProvider>
	);
});

export default Realtime;
